import AuthHelper from 'features/Auth/authHelper';
import AppRoute from 'general/constants/AppRoute';
import { Navigate } from 'react-router-dom';

// Route yeu cau phai dang nhap
// Neu chua dang nhap nhay ve man hinh dang nhap '/sign-in'
function PrivateRoute(props) {
  // MARK: --- Params ---
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;

  return isAuth ? props.children : <Navigate to={AppRoute.auth} />;
}

export default PrivateRoute;
